import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import axios from '../../../shared/axios/axiosProxy';
import i18n from '../../../utils/i18n';
import { withTranslation } from 'react-i18next';
//IMAGES
import call from '../../../images/icons/call.png';
import check from '../../../images/icons/check.png';
import StyledButton from '../../../shared/components/styledButton/styledButton';
//REDUX
import ACTIONS from '../../../redux/action';
import { useSelector, useDispatch } from 'react-redux';

function ReqContact({ provData, compData }) {
  const dispatch = useDispatch();

  const [open, setOpen] = React.useState(false);
  const [phone, setPhone] = React.useState('');
  const [sent, setSent] = React.useState(false);

  const [companyPhone] = useSelector((state) => [
    state.company_store.companyPhone,
  ]);
  const reqID = useParams().id;

  useEffect(() => {
    if (companyPhone) {
      setPhone(companyPhone);
    }
  }, [companyPhone]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const requestContact = (provData, compData) => {
    axios
      .patch(
        `/api/request/contact`,
        {
          reqID: reqID,
          providerID: provData.providerID,
          providerEmail: provData.providerEmail,
          providerContacted: true,
          companyPhone: phone,
          companyData: compData,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      )
      .then((response) => {
        console.log('AXIOS RESPONSE: ', response);
        setSent(true);
        setOpen(false);
      })
      .catch((error) => {
        console.log('AXIOS ERROR: ', error.response.data);
      });
  };

  return (
    <div style={{ marginTop: '0.5em', marginLeft: '-0.1em' }}>
      {sent ? (
        <img src={check} alt='check' />
      ) : (
        <IconButton
          onClick={(e) => {
            e.stopPropagation();
            handleClickOpen();
          }}
          size='large'
        >
          <img src={call} alt='phone' />
        </IconButton>
      )}
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby='form-dialog-title'
      >
        <DialogTitle id='form-dialog-title'>
          {i18n.t('request.initiatecontact')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {i18n.t('request.wishtocontact')}
          </DialogContentText>
          <TextField
            autoFocus
            margin='dense'
            id='phone'
            name='phone'  
            label={i18n.t('general.phonelabel')}
            type='text'
            value={phone}
            onChange={(event) => {
              setPhone(event.target.value);
            }}
            onBlur={(event) => {
              dispatch(
                ACTIONS.addCompanyInfo({
                  id: 'companyPhone',
                  data: event.target.value,
                  stateObject: 'company_store',
                })
              );
            }}
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <StyledButton onClick={handleClose} color='Secondary'>
            {i18n.t('general.closebutton')}
          </StyledButton>
          <StyledButton
            onClick={() => {
              requestContact(provData, compData);
            }}
            color='Primary'
          >
            {i18n.t('request.initiatecontact')}
          </StyledButton>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default withTranslation()(ReqContact);
